import { useCallback } from 'react';
import { getNameFromMetadata } from 'useCase';
import { reactionsStore } from 'state/store';
import { selectLocalParticipant } from 'state/selectors';
import { Reaction, ReactionType } from '../types';

const REACTION_DATA_TOPIC = 'reaction';

export const useSendReaction = () => {
    const sendReaction = useCallback((type: ReactionType) => {
        const localParticipant = selectLocalParticipant();
        if (!localParticipant) return;

        const participantName = getNameFromMetadata(localParticipant.metadata, '');
        const timestamp = Date.now();
        const nonce =
            typeof crypto !== 'undefined' && 'randomUUID' in crypto
                ? (crypto as any).randomUUID()
                : Math.random().toString(36).slice(2);

        const reactionData = {
            emojiString: type,
            participantId: localParticipant.identity,
            participantName,
            timestamp,
            nonce,
            sid: localParticipant.sid,
        };

        const reaction: Reaction = {
            type,
            participantId: localParticipant.identity,
            participantName,
            timestamp,
            id: `${localParticipant.identity}-${timestamp}-${nonce}`,
            colorIdentity: localParticipant.sid,
        };

        const encoder = new TextEncoder();
        const jsonString = JSON.stringify(reactionData);
        const data = encoder.encode(jsonString);

        localParticipant.publishData(data, { reliable: false, topic: REACTION_DATA_TOPIC });

        reactionsStore.addReaction(reaction);
        reactionsStore.setParticipantReaction(localParticipant.identity, type, timestamp);
    }, []);

    return sendReaction;
};
